export default __webpack_public_path__ + "static/landing_illustration-02bcb71d81ac3818f23011f31ba4644d.svg";